import React from 'react';
import { View, Text, StyleProp, ViewStyle } from 'react-native';

type ExpenseListSectionProps = {
  containerStyle?: StyleProp<ViewStyle>;
  titleRow: React.ReactNode;
  actions?: React.ReactNode;
  summary?: React.ReactNode;
  children: React.ReactNode;
  noData?: React.ReactNode;
  loading?: boolean;
};

const ExpenseListSection = ({
  containerStyle,
  titleRow,
  actions,
  summary,
  children,
  noData,
  loading = false,
}: ExpenseListSectionProps) => {
  return (
    <View style={containerStyle}>
      {titleRow}
      {actions}
      {summary}
      {loading ? noData : children}
    </View>
  );
};

export default ExpenseListSection;
